.siteShell {
  min-height: 100vh;
  overflow: clip;
}

/* Learning portal */
.accountLink {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid var(--line);
  border-radius: 100px;
  font-size: 11px;
  font-weight: 700;
  transition: background 200ms ease, color 200ms ease, transform 200ms var(--ease);
}

.accountLink svg {
  width: 17px;
}

.accountLink:hover {
  color: var(--paper);
  background: var(--teal);
  transform: translateY(-2px);
}

.lessonVisual > img,
.seriesTrailer > video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lessonPageLoading,
.portalLoading {
  min-height: 70vh;
  background: linear-gradient(90deg, transparent, rgba(217, 198, 164, 0.35), transparent);
  background-size: 220% 100%;
  animation: portalPulse 1.6s ease infinite;
}

@keyframes portalPulse {
  to { background-position: -220% 0; }
}

.lessonAccessMeta {
  display: flex;
  gap: 10px;
  margin-top: 24px;
}

.lessonAccessMeta span {
  padding: 8px 12px;
  border: 1px solid var(--line);
  border-radius: 100px;
  color: var(--ink-soft);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.videoFrame video {
  width: 100%;
  height: 100%;
  background: #000;
  object-fit: contain;
}

.lockedLesson {
  position: relative;
  z-index: 2;
  display: grid;
  place-items: center;
  align-content: center;
  width: 100%;
  height: 100%;
  padding: 40px;
  color: var(--paper);
  text-align: center;
}

.lockedLesson > svg {
  width: 42px;
  height: 42px;
  margin-bottom: 24px;
  color: var(--gold);
}

.lockedLesson strong {
  max-width: 760px;
  font-family: var(--display);
  font-size: clamp(28px, 4vw, 54px);
  font-weight: 400;
  line-height: 1.25;
}

.lockedLesson p {
  max-width: 620px;
  margin: 18px 0 28px;
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.7;
}

.lockedLesson .primaryButton {
  border-color: var(--paper);
  background: var(--paper);
  color: var(--teal);
}

.videoFrame[data-locked='true'] {
  aspect-ratio: auto;
}

.videoFrame[data-locked='true'] .lockedLesson {
  height: auto;
  min-height: 380px;
}

.playbackError {
  margin: 14px 0 0;
  color: var(--error);
}

.lessonDescription > div > p {
  max-width: 770px;
  margin: 0;
  font-family: var(--display);
  font-size: clamp(26px, 3vw, 42px);
  line-height: 1.4;
}

.completionButton {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin-top: 34px;
  padding: 13px 17px;
  border: 1px solid var(--line);
  border-radius: 100px;
  background: transparent;
  cursor: pointer;
}

.completionButton:disabled {
  color: var(--success);
  cursor: default;
}

.authPage {
  display: grid;
  grid-template-columns: 1.08fr 0.92fr;
  min-height: calc(100vh - 104px);
}

.authIntro,
.authPanel {
  display: grid;
  align-content: center;
  padding: clamp(48px, 8vw, 130px);
}

.authIntro {
  color: var(--paper);
  background: var(--teal-deep);
}

.authIntro h1 {
  max-width: 760px;
  margin: 0;
  font-family: var(--display);
  font-size: clamp(48px, 6vw, 92px);
  font-weight: 400;
  line-height: 1.05;
}

.authIntro > p:last-child {
  max-width: 620px;
  margin-top: 34px;
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.8;
}

.authPanel {
  background: var(--paper);
}

.authPanel form,
.authSuccess {
  display: grid;
  gap: 25px;
  width: min(520px, 100%);
  margin: auto;
}

.authPanel label,
.accessForm label,
.adminEditorForm label {
  display: grid;
  gap: 9px;
}

.authPanel label > span,
.accessForm label > span,
.adminEditorForm label > span {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.authPanel input,
.accessForm input,
.accessForm select,
.adminEditorForm input,
.adminEditorForm select,
.adminEditorForm textarea {
  width: 100%;
  min-height: 48px;
  padding: 10px 0;
  border: 0;
  border-bottom: 1px solid var(--ink);
  border-radius: 0;
  outline: 0;
  background: transparent;
}

.authPanel small,
.accessForm small,
.adminEditorForm small {
  color: var(--error);
}

.authTabs,
.adminTabs {
  display: flex;
  gap: 8px;
}

.authTabs {
  margin-bottom: 24px;
}

.authTabs button,
.adminTabs button {
  min-height: 44px;
  padding: 0 17px;
  border: 1px solid var(--line);
  border-radius: 100px;
  background: transparent;
  cursor: pointer;
}

.authTabs .authTabActive,
.adminTabs .adminTabActive {
  color: var(--paper);
  background: var(--teal);
}

.authBackLink {
  width: fit-content;
  color: var(--ink-soft);
  font-size: 12px;
}

.authSuccess > svg {
  width: 44px;
  height: 44px;
  color: var(--success);
}

.authSuccess h2 {
  margin: 8px 0 0;
  font-family: var(--display);
  font-size: 48px;
  font-weight: 400;
}

.authSuccess button {
  width: fit-content;
  padding: 12px 0;
  border: 0;
  border-bottom: 1px solid currentColor;
  background: transparent;
  cursor: pointer;
}

.portalGate {
  display: grid;
  justify-items: start;
  align-content: center;
  width: var(--container);
  min-height: calc(100vh - 104px);
  margin: 0 auto;
  padding: 90px 0 130px;
}

.portalGate > svg {
  width: 46px;
  height: 46px;
  margin-bottom: 35px;
  color: var(--gold);
}

.portalGate h1 {
  max-width: 980px;
  margin: 0;
  font-family: var(--display);
  font-size: clamp(48px, 7vw, 96px);
  font-weight: 400;
  line-height: 1.06;
}

.portalGate > p:not(.eyebrow) {
  max-width: 680px;
  margin: 28px 0;
  color: var(--ink-soft);
  line-height: 1.75;
}

.accountPage {
  width: var(--container);
  margin: 0 auto;
  padding: 90px 0 140px;
}

.accountHeader {
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 30px;
  padding-bottom: 55px;
  border-bottom: 1px solid var(--line);
}

.accountHeader h1 {
  max-width: 980px;
  margin: 0;
  font-family: var(--display);
  font-size: clamp(44px, 6vw, 82px);
  font-weight: 400;
  line-height: 1.08;
}

.accountHeader > div > p:last-child {
  color: var(--ink-soft);
}

.accountHeader > button,
.adminDashboard header > button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.accountStats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  margin: 32px 0 110px;
  background: var(--line);
  border: 1px solid var(--line);
}

.accountStats article {
  display: grid;
  min-height: 220px;
  padding: 28px;
  background: var(--paper);
}

.accountStats svg {
  color: var(--gold);
}

.accountStats strong {
  align-self: end;
  font-family: var(--display);
  font-size: 44px;
  font-weight: 400;
}

.accountStats span {
  color: var(--ink-soft);
  font-size: 12px;
}

.accountStats article[data-active='true'] {
  color: var(--paper);
  background: var(--teal);
}

.accountStats article[data-active='true'] span {
  color: rgba(255, 255, 255, 0.65);
}

.accountSectionHeader {
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 30px;
  margin-bottom: 46px;
}

.accountSectionHeader h2 {
  margin: 0;
  font-family: var(--display);
  font-size: clamp(40px, 5vw, 66px);
  font-weight: 400;
}

.adminDashboard {
  min-height: calc(100vh - 104px);
}

.adminTabs {
  margin-bottom: 36px;
}

.adminTabs button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.adminTabs svg {
  width: 17px;
}

.adminWorkspace,
.accessWorkspace {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(300px, 0.6fr);
  gap: 24px;
  align-items: start;
}

.adminEditorForm,
.accessForm,
.adminContentList,
.userDirectory {
  padding: clamp(24px, 4vw, 48px);
  border: 1px solid var(--line);
  background: var(--paper);
}

.adminFormHeading,
.adminListHeading {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 20px;
  margin-bottom: 42px;
}

.adminFormHeading h2 {
  margin: 0;
  font-family: var(--display);
  font-size: clamp(32px, 4vw, 52px);
  font-weight: 400;
}

.adminFormHeading > span {
  display: grid;
  place-items: center;
  width: 50px;
  height: 50px;
  border: 1px solid var(--line);
  border-radius: 50%;
  color: var(--gold);
}

.adminFieldGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px 24px;
}

.adminFullField {
  grid-column: 1 / -1;
}

.adminEditorForm textarea {
  resize: vertical;
}

.adminEditorForm progress {
  width: 100%;
  height: 6px;
  accent-color: var(--teal);
}

.adminCheckbox {
  grid-template-columns: auto 1fr;
  align-items: center;
  align-self: end;
}

.adminCheckbox input {
  width: 18px;
  min-height: 18px;
}

.adminEditorForm > .primaryButton,
.accessForm > .primaryButton {
  margin-top: 34px;
}

.formSuccess {
  color: var(--success);
}

.adminContentList,
.userDirectory {
  max-height: 880px;
  overflow: auto;
}

.adminListHeading strong {
  font-family: var(--display);
  font-size: 52px;
  font-weight: 400;
}

.adminContentList article {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
  padding: 22px 0;
  border-top: 1px solid var(--line);
}

.adminContentList h3,
.userDirectory h3 {
  margin: 6px 0;
  font-family: var(--display);
  font-size: 22px;
  font-weight: 400;
}

.adminContentList p,
.adminContentList span,
.userDirectory p,
.userDirectory span {
  margin: 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.adminContentList article > button {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border: 1px solid var(--line);
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
}

.accessForm {
  display: grid;
  gap: 25px;
}

.userDirectory article {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 14px;
  align-items: center;
  padding: 20px 0;
  border-top: 1px solid var(--line);
}

.userDirectory article > svg {
  color: var(--gold);
}

.userDirectory article > span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.userDirectory article > span svg {
  width: 14px;
}

@media (max-width: 1023px) {
  .accountLink span { display: none; }
  .accountLink { width: 40px; padding: 0; justify-content: center; }
  .authPage { grid-template-columns: 1fr; }
  .authIntro { min-height: 58vh; }
  .accountStats { grid-template-columns: 1fr; }
  .adminWorkspace,
  .accessWorkspace { grid-template-columns: 1fr; }
}

@media (max-width: 767px) {
  .accountLink { display: none; }
  .authIntro,
  .authPanel { padding: 64px 16px; }
  .authIntro h1 { font-size: 45px; }
  .authPanel { min-height: 70vh; }
  .portalGate { min-height: calc(100vh - 76px); padding: 70px 0 100px; }
  .portalGate h1 { font-size: 46px; }
  .lockedLesson { padding: 24px 18px; }
  .lockedLesson strong { font-size: 27px; }
  .lockedLesson p { font-size: 13px; }
  .accountPage { padding: 64px 0 100px; }
  .accountHeader { align-items: start; flex-direction: column; }
  .accountStats { margin-bottom: 80px; }
  .accountSectionHeader { align-items: start; flex-direction: column; }
  .adminTabs { overflow-x: auto; padding-bottom: 8px; }
  .adminTabs button { flex: 0 0 auto; }
  .adminFieldGrid { grid-template-columns: 1fr; }
  .adminFullField { grid-column: auto; }
  .adminEditorForm,
  .accessForm,
  .adminContentList,
  .userDirectory { padding: 24px 18px; }
  .userDirectory article { grid-template-columns: auto 1fr; }
  .userDirectory article > span { grid-column: 2; }
}

.header {
  position: relative;
  z-index: 40;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: var(--container);
  height: 104px;
  margin: 0 auto;
  border-bottom: 1px solid var(--line);
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  width: fit-content;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.brandMark {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  border: 1px solid var(--ink);
  border-radius: 50%;
  font-family: var(--display);
  font-size: 12px;
  letter-spacing: -0.04em;
}

.desktopNav {
  display: flex;
  align-items: center;
  gap: 32px;
}

.desktopNav a {
  position: relative;
  padding: 12px 0;
  font-size: 13px;
  font-weight: 600;
}

.desktopNav a::after {
  position: absolute;
  right: 0;
  bottom: 7px;
  left: 0;
  height: 1px;
  background: currentColor;
  content: '';
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 250ms var(--ease);
}

.desktopNav a:hover::after,
.desktopNav .navActive::after {
  transform: scaleX(1);
  transform-origin: left;
}

.headerActions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
}

.localeSwitch {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.localeSwitch button {
  padding: 7px 2px;
  border: 0;
  opacity: 0.45;
  background: transparent;
  cursor: pointer;
}

.localeSwitch button.localeActive {
  opacity: 1;
}

.menuButton {
  display: none;
  place-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 1px solid var(--line);
  border-radius: 50%;
  background: transparent;
}

.mobileMenu {
  position: fixed;
  z-index: 30;
  inset: 0;
  display: grid;
  align-items: center;
  padding: 100px 24px 32px;
  overflow-y: auto;
  background: var(--teal-deep);
  color: var(--paper);
  opacity: 0;
  pointer-events: none;
  transform: translateY(-24px);
  transition:
    opacity 350ms var(--ease),
    transform 350ms var(--ease);
}

.mobileMenuOpen {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.mobileMenu nav {
  display: grid;
}

.mobileMenu a {
  display: flex;
  align-items: baseline;
  gap: 20px;
  padding: 16px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  font-family: var(--display);
  font-size: clamp(32px, 10vw, 56px);
}

.mobileMenu a span {
  font-family: 'Manrope', sans-serif;
  font-size: 11px;
  color: var(--gold);
}

.eyebrow,
.sectionIndex {
  margin: 0 0 24px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.hero {
  width: var(--container);
  margin: 0 auto;
  padding: 56px 0 40px;
}

.heroMain {
  display: grid;
  grid-template-columns: minmax(360px, 0.78fr) minmax(0, 1.22fr);
  gap: clamp(44px, 5vw, 80px);
  align-items: center;
}

.heroCopy h1 {
  max-width: 650px;
  margin: 0;
  font-family: 'Manrope', sans-serif;
  font-size: clamp(48px, 4.6vw, 76px);
  font-weight: 600;
  line-height: 1.04;
  letter-spacing: -0.055em;
}

.heroLead {
  max-width: 520px;
  margin-top: 30px;
}

.heroLead > p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 16px;
  line-height: 1.7;
}

.heroActions,
.resultActions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.heroActions {
  margin-top: 28px;
}

.primaryButton,
.secondaryButton,
.lightButton {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  min-height: 52px;
  padding: 0 22px;
  border: 1px solid var(--teal);
  border-radius: 100px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition:
    transform 200ms var(--ease),
    color 200ms ease,
    background 200ms ease;
}

.primaryButton {
  background: var(--teal);
  color: var(--paper);
}

.secondaryButton {
  background: transparent;
  color: var(--teal);
}

.lightButton {
  border-color: var(--paper);
  color: var(--teal);
  background: var(--paper);
}

.primaryButton:hover,
.secondaryButton:hover,
.lightButton:hover {
  transform: translateY(-3px);
}

.secondaryButton:hover {
  background: var(--teal);
  color: var(--paper);
}

.heroPortrait,
.heroPortrait figure {
  min-width: 0;
  margin: 0;
}

.heroPortrait figure {
  position: relative;
  aspect-ratio: 1.18;
  overflow: hidden;
  border-radius: 28px;
  background: #8aa6b500;
}

.heroPortraitLink {
  display: block;
  border-radius: 28px;
}

.heroPortrait img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 34%;
  transition: transform 600ms var(--ease), filter 300ms ease;
}

.heroPortrait figure::after {
  position: absolute;
  inset: 45% 0 0;
  background: linear-gradient(#0000, #f2ebdc);
  content: '';
}

.heroPortrait figcaption {
  position: absolute;
  z-index: 1;
  right: 28px;
  bottom: 24px;
  left: 28px;
  display: grid;
  color: #123c34;
  gap: 5px;
}

.heroPortrait figcaption span {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: .13em;
  text-transform: uppercase;
}

.heroPortrait figcaption strong {
  font-family: var(--display);
  font-size: clamp(26px, 3vw, 42px);
  font-weight: 400;
}

.heroPortraitCta {
  position: absolute;
  z-index: 2;
  top: 24px;
  right: 24px;
  display: inline-flex;
  min-height: 44px;
  padding: 0 16px;
  border: 1px solid rgba(255, 255, 255, .46);
  border-radius: 100px;
  background: rgba(9, 43, 38, .74);
  color: var(--paper);
  font-size: 11px;
  font-weight: 700;
  align-items: center;
  gap: 9px;
  opacity: 0;
  transform: translateY(-8px);
  transition: opacity 220ms ease, transform 260ms var(--ease), background 220ms ease;
}

.heroPortraitCta svg {
  width: 16px;
  height: 16px;
  transition: transform 220ms var(--ease);
}

.heroPortraitLink:hover img,
.heroPortraitLink:focus-visible img {
  filter: saturate(.92);
  transform: scale(1.025);
}

.heroPortraitLink:hover .heroPortraitCta,
.heroPortraitLink:focus-visible .heroPortraitCta {
  opacity: 1;
  transform: translateY(0);
}

.heroPortraitLink:hover .heroPortraitCta svg,
.heroPortraitLink:focus-visible .heroPortraitCta svg {
  transform: translateX(3px);
}

.directionsSection {
  width: var(--container);
  margin: 0 auto;
  padding: 100px 0 130px;
}

.directionsLead {
  max-width: 390px;
  margin: 0;
  color: var(--ink-soft);
  font-size: 14px;
  line-height: 1.75;
}

.directionsHeaderAside {
  display: grid;
  max-width: 390px;
  justify-items: end;
  gap: 20px;
}

.directionsControls {
  display: flex;
  gap: 8px;
}

.directionsControls button {
  display: grid;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 1px solid var(--line);
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  place-items: center;
  transition: color 200ms ease, background 200ms ease, transform 200ms var(--ease);
}

.directionsControls button:hover {
  background: var(--teal);
  color: var(--paper);
  transform: translateY(-2px);
}

.directionsControls svg {
  width: 17px;
  height: 17px;
}

.directionsGrid {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: 20px;
  min-width: 0;
  margin-top: 44px;
  padding: 8px 0 20px;
  overflow-x: auto;
  overflow-y: hidden;
  cursor: grab;
  scroll-behavior: smooth;
  scroll-padding-inline: 0 20px;
  scroll-snap-type: x proximity;
  scrollbar-color: var(--gold) rgba(23, 51, 45, .08);
  scrollbar-width: thin;
  overscroll-behavior-inline: contain;
}

.directionsGrid::-webkit-scrollbar {
  height: 12px;
  background: transparent;
}

.directionsGrid::-webkit-scrollbar-track {
  border-radius: 100px;
  background: rgba(23, 51, 45, .06);
  box-shadow: inset 0 0 0 1px rgba(23, 51, 45, .08);
}

.directionsGrid::-webkit-scrollbar-thumb {
  min-width: 72px;
  border: 3px solid transparent;
  border-radius: 100px;
  background: var(--gold) padding-box;
  box-shadow: inset 0 0 0 1px rgba(9, 43, 38, .12);
}

.directionsGrid::-webkit-scrollbar-thumb:hover {
  background: #a98b57 padding-box;
}

.directionsGrid::-webkit-scrollbar-thumb:active {
  background: var(--teal) padding-box;
}

.directionsGrid::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}

.directionsGrid::-webkit-scrollbar-corner {
  background: transparent;
}

.directionsGrid > div {
  flex: 0 0 clamp(270px, 27vw, 360px);
  min-width: 0;
  scroll-snap-align: start;
}

.directionsGridDragging {
  cursor: grabbing;
  scroll-behavior: auto;
  scroll-snap-type: none;
  user-select: none;
}

.heroDirectionCard {
  position: relative;
  display: block;
  aspect-ratio: 0.86;
  overflow: hidden;
  border-radius: 22px;
  background: #9eb1a9;
  color: var(--paper);
  transition:
    transform 260ms var(--ease),
    box-shadow 260ms ease;
}

.heroDirectionCard[data-tone='1'] {
  background: #c4ad88;
}

.heroDirectionCard[data-tone='2'] {
  background: #779188;
}

.heroDirectionCard[data-tone='3'] {
  background: #b6a184;
}

.heroDirectionCard[data-tone='4'] {
  background: #8da39a;
}

.heroDirectionCard[data-tone='5'] {
  background: #a58c70;
}

.heroDirectionCard[data-tone='6'] {
  background: #6f8981;
}

.heroDirectionCard:hover {
  box-shadow: 0 18px 36px rgba(9, 43, 38, 0.15);
  transform: translateY(-6px);
}

.heroDirectionBadge {
  position: absolute;
  z-index: 3;
  top: 18px;
  left: 18px;
  padding: 7px 10px;
  border-radius: 100px;
  background: rgba(250, 246, 237, 0.9);
  color: var(--teal-deep);
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.heroDirectionArt {
  position: absolute;
  inset: 0 0 98px;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.heroDirectionArt::before,
.heroDirectionArt::after {
  position: absolute;
  width: 82%;
  aspect-ratio: 1;
  border: 1px solid rgba(9, 43, 38, 0.24);
  border-radius: 50%;
  content: '';
}

.heroDirectionArt::after {
  width: 56%;
  border-radius: 0;
  transform: rotate(45deg);
}

.heroDirectionArt:has(img)::before,
.heroDirectionArt:has(img)::after {
  display: none;
}

.heroDirectionArt span {
  position: absolute;
  right: -8px;
  bottom: -20px;
  color: rgba(250, 246, 237, 0.22);
  font-family: var(--display);
  font-size: 132px;
  line-height: 1;
}

.heroDirectionArt svg {
  z-index: 1;
  width: 56px;
  height: 56px;
  stroke-width: 1.2;
}

.heroDirectionArt img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 600ms var(--ease);
}

.heroDirectionCard:hover .heroDirectionArt img {
  transform: scale(1.04);
}

.heroDirectionBody {
  position: absolute;
  z-index: 2;
  right: 0;
  bottom: 0;
  left: 0;
  min-height: 110px;
  padding: 20px 46px 18px 20px;
  background: var(--teal-deep);
}

.heroDirectionBody h2 {
  margin: 0;
  font-family: var(--display);
  font-size: clamp(22px, 1.65vw, 28px);
  font-weight: 400;
  line-height: 1.2;
}

.heroDirectionBody p {
  margin: 10px 0 0;
  color: rgba(255, 255, 255, 0.58);
  font-size: 10px;
}

.heroDirectionBody svg {
  position: absolute;
  right: 18px;
  bottom: 20px;
  width: 18px;
  height: 18px;
}

.heroStats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-top: 42px;
}

.heroStats > div {
  display: grid;
  place-items: center;
  min-height: 82px;
  padding: 14px 20px;
  border: 1px solid var(--line);
  border-radius: 100px;
  text-align: center;
}

.heroStats strong {
  font-size: 20px;
  line-height: 1.15;
}

.heroStats span {
  color: var(--ink-soft);
  font-size: 10px;
}

.scrollCue {
  display: flex;
  align-items: center;
  gap: 10px;
  width: fit-content;
  margin: 30px auto 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.manifesto {
  padding: 140px max(32px, calc((100vw - 1320px) / 2));
  background: var(--teal-deep);
  color: var(--paper);
}

.manifestoText {
  max-width: 1120px;
  margin: 0;
  font-family: var(--display);
  font-size: clamp(42px, 5.4vw, 82px);
  line-height: 1.15;
  letter-spacing: -0.04em;
}

.manifestoText em {
  color: var(--gold);
  font-weight: 400;
}

.credentials {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  margin-top: 100px;
  background: rgba(255, 255, 255, 0.13);
}

.credential {
  min-height: 190px;
  padding: 26px;
  background: var(--teal-deep);
}

.credential svg {
  width: 25px;
  height: 25px;
  margin-bottom: 48px;
  color: var(--gold);
}

.credential span {
  display: block;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.44);
  font-size: 10px;
}

.credential p {
  margin: 0;
  font-size: 14px;
}

.aboutSection {
  width: var(--container);
  margin: 0 auto;
  padding: 136px 0;
}

.aboutGrid {
  display: grid;
  grid-template-columns: minmax(300px, 0.78fr) minmax(0, 1.22fr);
  gap: clamp(64px, 8vw, 132px);
  align-items: start;
}

.aboutIntro {
  position: sticky;
  top: 126px;
}

.aboutIntro h2 {
  margin: 0;
  font-family: var(--display);
  font-size: clamp(48px, 5.2vw, 76px);
  font-weight: 400;
  line-height: 1.04;
  letter-spacing: -0.04em;
}

.aboutLead {
  max-width: 520px;
  margin: 36px 0 0;
  color: var(--ink-soft);
  font-size: 17px;
  line-height: 1.75;
}

.aboutMission {
  max-width: 520px;
  margin: 42px 0 0;
  padding: 4px 0 4px 24px;
  border-left: 2px solid var(--gold);
  font-family: var(--display);
  font-size: clamp(21px, 2vw, 28px);
  line-height: 1.45;
}

.biographyList {
  border-top: 1px solid var(--line);
}

.biographyItem {
  display: grid;
  grid-template-columns: 48px 1fr;
  gap: 22px;
  padding: 27px 0;
  border-bottom: 1px solid var(--line);
}

.biographyItem span {
  color: var(--gold);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.biographyItem p {
  margin: 0;
  font-size: 16px;
  line-height: 1.72;
}

.aboutPageHero {
  display: grid;
  width: var(--container);
  margin: 0 auto;
  padding: 88px 0 112px;
  grid-template-columns: minmax(0, .88fr) minmax(0, 1.12fr);
  align-items: center;
  gap: clamp(52px, 7vw, 112px);
}

.aboutPageCopy h1 {
  max-width: 650px;
  margin: 0;
  font-family: var(--display);
  font-size: clamp(58px, 6.2vw, 96px);
  font-weight: 400;
  line-height: .98;
  letter-spacing: -.055em;
}

.aboutPageLead {
  max-width: 620px;
  margin: 36px 0 0;
  color: var(--ink-soft);
  font-size: clamp(17px, 1.5vw, 21px);
  line-height: 1.72;
}

.aboutPageCopy blockquote {
  max-width: 600px;
  margin: 44px 0 0;
  padding: 3px 0 3px 24px;
  border-left: 2px solid var(--gold);
  font-family: var(--display);
  font-size: clamp(20px, 1.8vw, 27px);
  line-height: 1.48;
}

.aboutPagePortrait figure {
  position: relative;
  aspect-ratio: .93;
  margin: 0;
  overflow: hidden;
  border-radius: 28px;
  background: #8aa6b5;
}

.aboutPagePortrait figure::after {
  position: absolute;
  inset: 54% 0 0;
  background: linear-gradient(180deg, transparent, rgba(9, 43, 38, .82));
  content: '';
}

.aboutPagePortrait img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 35%;
}

.aboutPagePortrait figcaption {
  position: absolute;
  z-index: 1;
  right: 30px;
  bottom: 28px;
  left: 30px;
  display: grid;
  color: var(--paper);
  gap: 7px;
}

.aboutPagePortrait figcaption span {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: .13em;
  text-transform: uppercase;
}

.aboutPagePortrait figcaption strong {
  font-family: var(--display);
  font-size: clamp(28px, 3vw, 44px);
  font-weight: 400;
}

.aboutPillars {
  display: grid;
  width: var(--container);
  margin: 0 auto;
  background: var(--teal-deep);
  color: var(--paper);
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.aboutPillars > div + div {
  border-left: 1px solid rgba(255, 255, 255, .13);
}

.aboutPillars article {
  min-height: 350px;
  padding: clamp(28px, 3.5vw, 48px);
}

.aboutPillars article > span {
  color: rgba(255, 255, 255, .42);
  font-size: 10px;
  letter-spacing: .12em;
}

.aboutPillars svg {
  display: block;
  width: 30px;
  height: 30px;
  margin: 64px 0 30px;
  color: var(--gold);
  stroke-width: 1.4;
}

.aboutPillars h2 {
  margin: 0;
  font-family: var(--display);
  font-size: clamp(25px, 2vw, 34px);
  font-weight: 400;
  line-height: 1.25;
}

.aboutPillars p {
  margin: 22px 0 0;
  color: rgba(255, 255, 255, .64);
  font-size: 14px;
  line-height: 1.7;
}

.aboutBiographySection {
  display: grid;
  width: var(--container);
  margin: 0 auto;
  padding: 142px 0;
  grid-template-columns: minmax(270px, .72fr) minmax(0, 1.28fr);
  align-items: start;
  gap: clamp(56px, 8vw, 132px);
}

.aboutBiographyIntro {
  position: sticky;
  top: 126px;
}

.aboutBiographyIntro h2 {
  margin: 0;
  font-family: var(--display);
  font-size: clamp(46px, 5vw, 72px);
  font-weight: 400;
  line-height: 1.05;
  letter-spacing: -.04em;
}

.aboutBiographyIntro > p:last-child {
  max-width: 440px;
  margin: 32px 0 0;
  color: var(--ink-soft);
  font-size: 15px;
  line-height: 1.72;
}

.aboutPageCallout {
  width: var(--container);
  margin: 0 auto 110px;
  padding: clamp(44px, 7vw, 94px);
  background: var(--teal);
  color: var(--paper);
  text-align: center;
}

.aboutPageCallout > div {
  display: grid;
  justify-items: center;
}

.aboutPageCallout > div > svg {
  width: 34px;
  height: 34px;
  margin-bottom: 38px;
  color: var(--gold);
  stroke-width: 1.4;
}

.aboutPageCallout h2 {
  max-width: 820px;
  margin: 0 0 40px;
  font-family: var(--display);
  font-size: clamp(38px, 5vw, 70px);
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: -.04em;
}

.section,
.topicsSection,
.editorialSection,
.catalogSection,
.quizCatalog,
.blogList {
  width: var(--container);
  margin: 0 auto;
  padding: 136px 0;
}

.sectionHeader {
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 32px;
  margin-bottom: 54px;
}

.sectionHeader h2,
.quizBand h2,
.contactCallout h2,
.relatedSection h2 {
  max-width: 760px;
  margin: 0;
  font-family: var(--display);
  font-size: clamp(42px, 5vw, 72px);
  font-weight: 400;
  line-height: 1.08;
  letter-spacing: -0.04em;
}

.inlineLink {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding-bottom: 7px;
  border-bottom: 1px solid currentColor;
  font-size: 13px;
  font-weight: 700;
}

.inlineLink svg {
  transition: transform 200ms var(--ease);
}

.inlineLink:hover svg {
  transform: translateX(4px);
}

.cardGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}

.lessonCard {
  position: relative;
  display: block;
  transition: transform 280ms var(--ease);
}

.lessonCard:hover {
  transform: translateY(-7px);
}

.lessonVisual {
  position: relative;
  display: grid;
  place-items: center;
  aspect-ratio: 16 / 10;
  overflow: hidden;
  background: #d0b894;
}

.lessonVisual[data-tone='1'] {
  background: #809990;
}

.lessonVisual[data-tone='2'] {
  background: #a99b82;
}

.lessonVisual::before,
.lessonVisual::after {
  position: absolute;
  width: 58%;
  aspect-ratio: 1;
  border: 1px solid rgba(9, 43, 38, 0.25);
  border-radius: 50%;
  content: '';
}

.lessonVisual::after {
  width: 38%;
  border-radius: 0;
  transform: rotate(45deg);
}

.demoBadge,
.duration {
  position: absolute;
  z-index: 2;
  top: 16px;
  padding: 7px 10px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: rgba(9, 43, 38, 0.58);
  color: white;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.demoBadge {
  left: 16px;
}

.duration {
  right: 16px;
}

.playDisc {
  z-index: 2;
  display: grid;
  place-items: center;
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: var(--paper);
  color: var(--teal);
  transition: transform 250ms var(--ease);
}

.lessonCard:hover .playDisc {
  transform: scale(1.08);
}

.lessonBody {
  position: relative;
  min-height: 156px;
  padding: 22px 46px 18px 0;
  border-bottom: 1px solid var(--line);
}

.metaRow {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: var(--ink-soft);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.lessonBody h3 {
  margin: 20px 0 0;
  font-family: var(--display);
  font-size: clamp(22px, 2.1vw, 30px);
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: -0.025em;
}

.cardArrow {
  position: absolute;
  right: 0;
  bottom: 20px;
}

.quizBand {
  display: grid;
  grid-template-columns: 0.8fr 1.2fr;
  gap: 8vw;
  padding: 136px max(32px, calc((100vw - 1320px) / 2));
  background: #d9c6a4;
}

.quizBand > div:first-child > p:last-child {
  max-width: 520px;
  margin: 28px 0 0;
  color: var(--ink-soft);
  line-height: 1.75;
}

.quizTeasers {
  display: grid;
  gap: 16px;
}

.quizTeaser {
  position: relative;
  display: block;
  min-height: 210px;
  padding: 30px 80px 30px 30px;
  border: 1px solid rgba(23, 51, 45, 0.24);
  transition:
    background 250ms ease,
    color 250ms ease,
    transform 250ms var(--ease);
}

.quizTeaser:hover {
  color: var(--paper);
  background: var(--teal);
  transform: translateX(8px);
}

.quizTeaser > span {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.quizTeaser h3 {
  max-width: 560px;
  margin: 36px 0 20px;
  font-family: var(--display);
  font-size: 30px;
  font-weight: 400;
}

.quizTeaser p {
  margin: 0;
  font-size: 12px;
}

.quizTeaser svg {
  position: absolute;
  right: 28px;
  bottom: 28px;
}

.topicList {
  border-top: 1px solid var(--line);
}

.topicList a {
  display: grid;
  grid-template-columns: 90px 1fr auto;
  align-items: center;
  min-height: 112px;
  border-bottom: 1px solid var(--line);
  transition:
    padding 220ms var(--ease),
    background 220ms ease;
}

.topicList a:hover {
  padding-right: 20px;
  padding-left: 20px;
  background: rgba(217, 198, 164, 0.32);
}

.topicList span {
  font-size: 10px;
  color: var(--gold);
}

.topicList strong {
  font-family: var(--display);
  font-size: clamp(29px, 3.6vw, 52px);
  font-weight: 400;
}

.editorialSection {
  border-top: 1px solid var(--line);
}

.postGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  background: var(--line);
}

.postCard {
  display: flex;
  flex-direction: column;
  min-height: 330px;
  padding: 36px;
  background: var(--paper);
  transition:
    color 250ms ease,
    background 250ms ease;
}

.postCard:hover {
  color: var(--paper);
  background: var(--teal);
}

.postCard > p {
  margin: 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.postCard h3 {
  max-width: 540px;
  margin: auto 0;
  font-family: var(--display);
  font-size: clamp(29px, 3vw, 43px);
  font-weight: 400;
  line-height: 1.18;
}

.postCard > span {
  font-size: 11px;
}

.contactCallout {
  min-height: 600px;
  padding: 140px max(32px, calc((100vw - 1320px) / 2));
  background: var(--teal);
  color: var(--paper);
}

.contactCallout h2 {
  max-width: 900px;
  margin-bottom: 50px;
  font-size: clamp(52px, 7vw, 100px);
}

.footer {
  padding: 90px max(32px, calc((100vw - 1320px) / 2)) 34px;
  background: var(--teal-deep);
  color: var(--paper);
}

.footerTitle {
  max-width: 650px;
  margin: 0 0 18px;
  font-family: var(--display);
  font-size: clamp(38px, 4vw, 60px);
  line-height: 1.15;
}

.footer > div:first-child > p:last-child {
  color: var(--sand);
}

.footerLinks {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  margin: 70px 0;
}

.footerLinks a {
  padding-bottom: 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
}

.footerBottom {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding-top: 28px;
  border-top: 1px solid rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.55);
  font-size: 10px;
}

.footerBottom span {
  margin-right: auto;
}

.pageIntro {
  width: var(--container);
  margin: 0 auto;
  padding: 120px 0 90px;
  border-bottom: 1px solid var(--line);
}

.pageIntro h1,
.lessonHeader h1,
.articlePage header h1,
.adminSetup h1,
.adminLogin h1,
.adminDashboard h1 {
  max-width: 1050px;
  margin: 0;
  font-family: var(--display);
  font-size: clamp(64px, 9vw, 138px);
  font-weight: 400;
  line-height: 0.95;
  letter-spacing: -0.06em;
}

.introText {
  max-width: 650px;
  margin: 44px 0 0 auto;
  color: var(--ink-soft);
  font-size: 17px;
  line-height: 1.8;
}

.catalogSection {
  padding-top: 54px;
}

.catalogToolbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 32px;
  margin-bottom: 56px;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filters button {
  min-height: 44px;
  padding: 0 15px;
  border: 1px solid var(--line);
  border-radius: 100px;
  background: transparent;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.filters button.filterActive {
  color: var(--paper);
  background: var(--teal);
}

.searchField {
  display: flex;
  flex: 0 0 260px;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 0 15px;
  border-bottom: 1px solid var(--ink);
}

.searchField input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

.skeletonCard {
  min-height: 360px;
  padding: 24px;
  background: rgba(217, 198, 164, 0.38);
  animation: pulse 1.5s ease-in-out infinite alternate;
}

.skeletonCard span {
  display: block;
  width: 100%;
  height: 12px;
  margin-bottom: 15px;
  background: rgba(23, 51, 45, 0.11);
}

.skeletonCard span:first-child {
  height: 220px;
}

.skeletonCard span:last-child {
  width: 60%;
}

@keyframes pulse {
  to {
    opacity: 0.5;
  }
}

.stateCard {
  display: grid;
  place-items: center;
  min-height: 300px;
  padding: 50px;
  border: 1px solid var(--line);
  text-align: center;
}

.stateCard svg {
  width: 34px;
  height: 34px;
  color: var(--gold);
}

.textButton {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1px solid var(--line);
  background: transparent;
  cursor: pointer;
}

.lessonPage,
.articlePage {
  width: var(--container);
  margin: 0 auto;
  padding: 56px 0 130px;
}

.lessonPage {
  padding-top: 32px;
}

.backLink {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 70px;
  font-size: 12px;
  font-weight: 700;
}

.lessonPage > .backLink {
  margin-bottom: 28px;
}

.lessonHeader {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 30px;
  align-items: end;
  margin-bottom: 28px;
}

.lessonHeader h1 {
  max-width: 1080px;
  font-size: clamp(32px, 3.6vw, 52px);
  line-height: 1.2;
  letter-spacing: -0.035em;
}

.lessonHeader .eyebrow {
  margin-bottom: 14px;
}

.lessonHeader .lessonAccessMeta {
  margin-top: 16px;
}

.articlePage header h1 {
  max-width: 1080px;
  font-size: clamp(52px, 7vw, 104px);
  line-height: 1.03;
}

.shareButton {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  min-height: 48px;
  padding: 0 18px;
  border: 1px solid var(--line);
  border-radius: 100px;
  background: transparent;
  cursor: pointer;
}

.videoFrame {
  position: relative;
  aspect-ratio: 16 / 8.6;
  overflow: hidden;
  background: var(--teal-deep);
}

.videoFrame iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

.videoFrame > button {
  display: grid;
  place-items: center;
  gap: 18px;
  width: 100%;
  height: 100%;
  border: 0;
  color: var(--paper);
  background: transparent;
  cursor: pointer;
}

.videoFrame > button::before,
.videoFrame > button::after {
  position: absolute;
  width: 42%;
  aspect-ratio: 1;
  border: 1px solid rgba(217, 198, 164, 0.24);
  border-radius: 50%;
  content: '';
}

.videoFrame > button::after {
  width: 27%;
  border-radius: 0;
  transform: rotate(45deg);
}

.videoFrame > button > * {
  z-index: 2;
}

.videoFrame button:disabled {
  cursor: default;
}

.videoFrame small {
  color: var(--sand);
  font-size: 9px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.lessonDescription {
  display: grid;
  grid-template-columns: 0.5fr 1fr;
  gap: 40px;
  padding: 80px 0;
  border-bottom: 1px solid var(--line);
}

.lessonDescription > p:last-child {
  max-width: 770px;
  margin: 0;
  font-family: var(--display);
  font-size: clamp(26px, 3vw, 42px);
  line-height: 1.4;
}

.relatedSection {
  padding-top: 100px;
}

.relatedSection h2 {
  margin-bottom: 50px;
}

.quizCatalog {
  padding-top: 45px;
}

.quizRow {
  position: relative;
  display: grid;
  grid-template-columns: 80px 1fr minmax(170px, 0.4fr) 32px;
  gap: 34px;
  align-items: center;
  min-height: 230px;
  padding: 36px 0;
  border-bottom: 1px solid var(--line);
  transition:
    padding 250ms var(--ease),
    background 250ms ease;
}

.quizRow:first-of-type {
  border-top: 1px solid var(--line);
}

.quizRow:hover {
  padding-right: 24px;
  padding-left: 24px;
  background: rgba(217, 198, 164, 0.3);
}

.quizNumber {
  align-self: start;
  color: var(--gold);
  font-size: 11px;
}

.quizRow h2 {
  margin: 14px 0;
  font-family: var(--display);
  font-size: clamp(28px, 3.3vw, 48px);
  font-weight: 400;
}

.quizRow p {
  max-width: 650px;
  margin: 0;
  color: var(--ink-soft);
  line-height: 1.6;
}

.quizRow p:first-child {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.quizStats {
  display: grid;
  gap: 12px;
  color: var(--ink-soft);
  font-size: 11px;
}

.quizStats span {
  display: flex;
  align-items: center;
  gap: 6px;
}

.quizExperience {
  min-height: calc(100vh - 104px);
  padding: 42px max(24px, calc((100vw - 1080px) / 2)) 90px;
  background: var(--paper);
}

.quizTopbar {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 20px;
  font-size: 11px;
  font-weight: 700;
}

.quizTopbar span:last-child {
  text-align: right;
}

.progressTrack {
  width: 100%;
  height: 2px;
  margin: 22px 0 78px;
  background: var(--line);
}

.progressTrack span {
  display: block;
  height: 100%;
  background: var(--gold);
}

.questionCard,
.resultCard {
  max-width: 900px;
  margin: 0 auto;
}

.questionCard h1,
.resultCard h1 {
  margin: 0 0 50px;
  font-family: var(--display);
  font-size: clamp(36px, 5vw, 62px);
  font-weight: 400;
  line-height: 1.2;
  text-align: center;
}

.questionCard > .eyebrow,
.resultCard > .eyebrow {
  text-align: center;
}

.optionsList {
  display: grid;
  gap: 12px;
}

.optionButton {
  display: grid;
  grid-template-columns: 44px 1fr auto;
  gap: 16px;
  align-items: center;
  min-height: 72px;
  padding: 12px 20px 12px 12px;
  border: 1px solid var(--line);
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition:
    border-color 200ms ease,
    transform 200ms var(--ease),
    background 200ms ease;
}

.optionButton:hover:not(:disabled) {
  border-color: var(--teal);
  transform: translateX(5px);
}

.optionButton > span {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(217, 198, 164, 0.38);
  font-weight: 700;
}

.optionCorrect,
.optionCorrectHint {
  border-color: var(--success);
  background: rgba(76, 119, 91, 0.11);
}

.optionWrong {
  border-color: var(--error);
  background: rgba(154, 77, 62, 0.1);
}

.explanation {
  margin-top: 30px;
  padding: 28px;
  border-left: 3px solid var(--gold);
  background: rgba(217, 198, 164, 0.22);
}

.explanation p {
  max-width: 720px;
  margin: 10px 0 24px;
  color: var(--ink-soft);
  line-height: 1.7;
}

.resultCard {
  text-align: center;
}

.scoreCircle {
  display: grid;
  place-items: center;
  width: 170px;
  height: 170px;
  margin: 0 auto 40px;
  border: 1px solid var(--gold);
  border-radius: 50%;
}

.scoreCircle strong {
  font-family: var(--display);
  font-size: 68px;
  font-weight: 400;
  line-height: 1;
}

.scoreCircle span {
  margin-top: -28px;
  color: var(--ink-soft);
}

.resultCard > p:not(.eyebrow) {
  max-width: 650px;
  margin: -25px auto 35px;
  color: var(--ink-soft);
  line-height: 1.8;
}

.resultActions {
  justify-content: center;
}

.blogList {
  padding-top: 40px;
}

.blogRow {
  display: grid;
  grid-template-columns: 80px 1fr minmax(150px, 0.3fr);
  gap: 30px;
  min-height: 260px;
  padding: 44px 0;
  border-bottom: 1px solid var(--line);
  transition:
    padding 250ms var(--ease),
    background 250ms ease;
}

.blogRow:first-of-type {
  border-top: 1px solid var(--line);
}

.blogRow:hover {
  padding-right: 24px;
  padding-left: 24px;
  background: rgba(217, 198, 164, 0.28);
}

.blogIndex {
  color: var(--gold);
  font-size: 11px;
}

.blogRow h2 {
  margin: 16px 0 20px;
  font-family: var(--display);
  font-size: clamp(31px, 4vw, 58px);
  font-weight: 400;
  line-height: 1.15;
}

.blogRow div > p:last-child {
  max-width: 680px;
  color: var(--ink-soft);
  line-height: 1.7;
}

.blogMeta {
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 12px;
  color: var(--ink-soft);
  font-size: 10px;
  text-transform: uppercase;
}

.blogMeta svg {
  margin-top: auto;
  color: var(--ink);
}

.articlePage {
  max-width: 1180px;
}

.articlePage header {
  padding-bottom: 70px;
  border-bottom: 1px solid var(--line);
}

.articleMeta {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 45px;
  color: var(--ink-soft);
  font-size: 11px;
}

.articleMeta button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.articleBody {
  max-width: 760px;
  margin: 80px auto 0;
  font-size: 18px;
  line-height: 1.9;
}

.articleLead {
  font-family: var(--display);
  font-size: clamp(26px, 3.1vw, 40px);
  line-height: 1.5;
}

.articleBody blockquote {
  margin: 70px -110px;
  padding: 0 0 0 40px;
  border-left: 2px solid var(--gold);
  font-family: var(--display);
  font-size: clamp(29px, 3.5vw, 48px);
  line-height: 1.4;
}

.articleBody h2 {
  margin: 70px 0 25px;
  font-family: var(--display);
  font-size: 38px;
  font-weight: 400;
}

.contactGrid {
  display: grid;
  grid-template-columns: 0.75fr 1.25fr;
  gap: 8vw;
  width: var(--container);
  margin: 0 auto;
  padding: 90px 0 140px;
}

.contactAside > a {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 14px;
  align-items: center;
  padding: 24px 0;
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  font-family: var(--display);
  font-size: clamp(23px, 2.5vw, 34px);
}

.contactAside > p:last-child {
  max-width: 400px;
  margin-top: 30px;
  color: var(--ink-soft);
  line-height: 1.7;
}

.contactForm {
  display: grid;
  gap: 32px;
}

.contactForm label,
.adminLogin label {
  display: grid;
  gap: 10px;
}

.contactForm label > span,
.adminLogin label > span {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.contactForm input,
.contactForm select,
.contactForm textarea,
.adminLogin input {
  width: 100%;
  padding: 14px 0;
  border: 0;
  border-bottom: 1px solid var(--ink);
  border-radius: 0;
  outline: 0;
  background: transparent;
  font-size: 17px;
}

.contactForm textarea {
  resize: vertical;
}

.contactForm small,
.adminLogin small,
.formError {
  color: var(--error);
  font-size: 11px;
}

.contactForm .primaryButton {
  width: fit-content;
  margin-top: 16px;
}

.contactForm .primaryButton:disabled {
  cursor: progress;
  opacity: 0.62;
}

.successCard {
  display: grid;
  place-items: start;
  align-content: center;
  min-height: 480px;
  padding: 54px;
  background: var(--teal);
  color: var(--paper);
}

.successCard > svg {
  width: 40px;
  height: 40px;
  margin-bottom: 35px;
  color: var(--sand);
}

.successCard h2 {
  margin: 0;
  font-family: var(--display);
  font-size: clamp(35px, 4vw, 54px);
  font-weight: 400;
}

.successCard p {
  max-width: 580px;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.7;
}

.successCard button {
  margin-top: 20px;
  padding: 12px 0;
  border: 0;
  border-bottom: 1px solid currentColor;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.adminSetup,
.adminLogin,
.adminDashboard {
  width: var(--container);
  min-height: calc(100vh - 104px);
  margin: 0 auto;
  padding: 100px 0 140px;
}

.adminSetup > svg {
  width: 44px;
  height: 44px;
  margin-bottom: 40px;
  color: var(--gold);
}

.adminSetup h1,
.adminLogin h1,
.adminDashboard h1 {
  max-width: 900px;
  font-size: clamp(45px, 6vw, 86px);
}

.adminSetup > p:not(.eyebrow) {
  max-width: 670px;
  margin: 36px 0;
  color: var(--ink-soft);
  line-height: 1.8;
}

.adminSetup code {
  display: inline-block;
  padding: 16px;
  background: rgba(217, 198, 164, 0.4);
}

.adminLogin {
  display: grid;
  place-items: center;
}

.adminLogin form {
  display: grid;
  gap: 28px;
  width: min(520px, 100%);
  padding: 48px;
  border: 1px solid var(--line);
  background: var(--paper);
}

.adminLogin h1 {
  margin-bottom: 20px;
  font-size: 50px;
}

.adminDashboard header {
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 30px;
  margin-bottom: 70px;
}

.adminDashboard header button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.adminCards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}

.adminCards article {
  min-height: 280px;
  padding: 30px;
  border: 1px solid var(--line);
}

.adminCards article > svg {
  color: var(--gold);
}

.adminCards h2 {
  margin-top: 60px;
  font-family: var(--display);
  font-size: 34px;
  font-weight: 400;
}

.adminCards p,
.adminCards span {
  color: var(--ink-soft);
  font-size: 13px;
  line-height: 1.6;
}

.adminCards span {
  display: block;
  margin-top: 24px;
  font-size: 10px;
}

.notFound {
  display: grid;
  place-items: center;
  align-content: center;
  min-height: calc(100vh - 104px);
  padding: 70px 24px;
  text-align: center;
}

.notFound > p {
  margin: 0;
  color: var(--gold);
  font-family: var(--display);
  font-size: 120px;
  line-height: 1;
}

.notFound h1 {
  margin: 24px 0 40px;
  font-family: var(--display);
  font-size: clamp(36px, 6vw, 70px);
  font-weight: 400;
}

@media (max-width: 1023px) {
  .header {
    grid-template-columns: 1fr auto;
    height: 88px;
  }

  .desktopNav {
    display: none;
  }

  .menuButton {
    display: grid;
  }

  .hero {
    padding: 48px 0 44px;
  }

  .heroMain {
    grid-template-columns: minmax(290px, 0.76fr) minmax(0, 1.24fr);
    gap: 30px;
  }

  .heroCopy h1 {
    font-size: clamp(42px, 5.6vw, 58px);
  }

  .heroStats {
    grid-template-columns: repeat(2, 1fr);
  }

  .directionsGrid > div {
    flex-basis: min(40vw, 320px);
  }

  .credentials {
    grid-template-columns: repeat(2, 1fr);
  }

  .aboutGrid {
    grid-template-columns: 0.88fr 1.12fr;
    gap: 54px;
  }

  .aboutPageHero {
    gap: 44px;
  }

  .aboutPillars article {
    min-height: 320px;
    padding: 34px 28px;
  }

  .aboutBiographySection {
    grid-template-columns: minmax(240px, .78fr) minmax(0, 1.22fr);
    gap: 54px;
  }

  .quizBand {
    grid-template-columns: 1fr;
  }

  .cardGrid {
    grid-template-columns: repeat(2, 1fr);
  }

  .lessonDescription {
    grid-template-columns: 1fr;
  }

  .quizRow {
    grid-template-columns: 50px 1fr 30px;
  }

  .quizStats {
    grid-column: 2;
    grid-row: 2;
    grid-template-columns: repeat(3, auto);
    justify-content: start;
  }

  .quizArrow {
    grid-column: 3;
    grid-row: 1 / span 2;
  }

  .blogRow {
    grid-template-columns: 50px 1fr;
  }

  .blogMeta {
    grid-column: 2;
    flex-direction: row;
    align-items: center;
  }

  .blogMeta svg {
    margin-top: 0;
    margin-left: auto;
  }

  .contactGrid {
    grid-template-columns: 1fr;
  }

  .adminCards {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .header {
    height: 76px;
  }

  .brand {
    font-size: 9px;
  }

  .brandMark {
    width: 34px;
    height: 34px;
  }

  .localeSwitch {
    display: none;
  }

  .hero {
    padding: 42px 0 34px;
  }

  .heroMain {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .heroCopy h1 {
    font-size: clamp(42px, 13vw, 58px);
  }

  .heroLead {
    margin-top: 24px;
  }

  .heroActions {
    display: grid;
  }

  .heroPortrait figure {
    aspect-ratio: .95;
  }

  .directionsSection {
    padding: 76px 0 92px;
  }

  .directionsSection .sectionHeader {
    align-items: start;
  }

  .directionsLead {
    margin-top: 24px;
  }

  .directionsHeaderAside {
    justify-items: start;
  }

  .directionsGrid {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    gap: 14px;
    width: calc(100vw - 16px);
    margin-right: -16px;
    margin-top: 30px;
    padding: 6px 16px 6px 0;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-padding-inline: 0 16px;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
  }

  .directionsGrid::-webkit-scrollbar {
    display: none;
  }

  .directionsGrid > div {
    flex: 0 0 min(74vw, 290px);
    scroll-snap-align: start;
  }

  .aboutPageHero {
    padding: 58px 0 86px;
    grid-template-columns: 1fr;
    gap: 48px;
  }

  .aboutPageCopy h1 {
    font-size: clamp(48px, 15vw, 68px);
  }

  .aboutPageLead {
    margin-top: 28px;
    font-size: 17px;
  }

  .aboutPageCopy blockquote {
    margin-top: 34px;
    padding-left: 18px;
  }

  .aboutPagePortrait figure {
    aspect-ratio: .88;
    border-radius: 22px;
  }

  .aboutPillars {
    grid-template-columns: 1fr;
  }

  .aboutPillars > div + div {
    border-top: 1px solid rgba(255, 255, 255, .13);
    border-left: 0;
  }

  .aboutPillars article {
    min-height: 0;
    padding: 34px 28px 42px;
  }

  .aboutPillars svg {
    margin: 44px 0 26px;
  }

  .aboutBiographySection {
    padding: 100px 0;
    grid-template-columns: 1fr;
    gap: 54px;
  }

  .aboutBiographyIntro {
    position: static;
  }

  .aboutPageCallout {
    margin-bottom: 70px;
    padding: 54px 24px;
  }

  .heroStats {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-top: 30px;
  }

  .heroStats > div {
    min-height: 74px;
    padding: 12px;
    border-radius: 18px;
  }

  .scrollCue {
    margin-top: 26px;
  }

  .manifesto {
    padding: 100px 16px;
  }

  .manifestoText {
    font-size: 38px;
  }

  .credentials {
    grid-template-columns: 1fr 1fr;
    margin-top: 70px;
  }

  .credential {
    min-height: 160px;
    padding: 18px;
  }

  .credential svg {
    margin-bottom: 35px;
  }

  .aboutSection {
    padding: 100px 0;
  }

  .aboutGrid {
    grid-template-columns: 1fr;
    gap: 68px;
  }

  .aboutIntro {
    position: static;
  }

  .aboutIntro h2 {
    font-size: 48px;
  }

  .aboutLead {
    margin-top: 28px;
    font-size: 16px;
  }

  .aboutMission {
    margin-top: 32px;
    font-size: 22px;
  }

  .biographyItem {
    grid-template-columns: 34px 1fr;
    gap: 12px;
    padding: 24px 0;
  }

  .biographyItem p {
    font-size: 15px;
  }

  .section,
  .topicsSection,
  .editorialSection,
  .catalogSection,
  .quizCatalog,
  .blogList {
    padding: 90px 0;
  }

  .sectionHeader {
    display: grid;
    margin-bottom: 38px;
  }

  .sectionHeader h2,
  .quizBand h2,
  .contactCallout h2 {
    font-size: 42px;
  }

  .cardGrid,
  .postGrid {
    grid-template-columns: 1fr;
  }

  .quizBand,
  .contactCallout {
    padding: 90px 16px;
  }

  .topicList a {
    grid-template-columns: 44px 1fr auto;
    min-height: 86px;
  }

  .topicList strong {
    font-size: 27px;
  }

  .postCard {
    min-height: 280px;
    padding: 26px;
  }

  .footer {
    padding: 75px 16px 28px;
  }

  .footerBottom {
    display: grid;
  }

  .pageIntro {
    padding: 80px 0 60px;
  }

  .pageIntro h1 {
    font-size: 62px;
  }

  .introText {
    margin-top: 30px;
    font-size: 16px;
  }

  .catalogToolbar {
    display: grid;
  }

  .filters {
    flex-wrap: nowrap;
    width: calc(100vw - 16px);
    padding-right: 16px;
    overflow-x: auto;
    scrollbar-width: none;
  }

  .filters button {
    flex: 0 0 auto;
  }

  .searchField {
    width: 100%;
  }

  .lessonPage,
  .articlePage {
    padding-top: 35px;
  }

  .lessonPage {
    padding-top: 24px;
  }

  .backLink {
    margin-bottom: 48px;
  }

  .lessonPage > .backLink {
    margin-bottom: 20px;
  }

  .lessonHeader {
    grid-template-columns: 1fr;
    margin-bottom: 24px;
  }

  .lessonHeader h1 {
    font-size: clamp(28px, 7vw, 34px);
    line-height: 1.25;
  }

  .articlePage header h1 {
    font-size: 47px;
  }

  .shareButton {
    width: fit-content;
  }

  .videoFrame {
    aspect-ratio: 1.15;
  }

  .lessonDescription {
    padding: 55px 0;
  }

  .lessonDescription > p:last-child {
    font-size: 26px;
  }

  .quizRow {
    grid-template-columns: 36px 1fr;
    gap: 16px;
    padding: 30px 0;
  }

  .quizStats {
    grid-column: 2;
    grid-template-columns: 1fr;
  }

  .quizArrow {
    display: none;
  }

  .quizExperience {
    min-height: 100vh;
    padding: 30px 16px 70px;
  }

  .quizTopbar {
    grid-template-columns: 1fr auto;
  }

  .quizTopbar span:nth-child(2) {
    display: none;
  }

  .progressTrack {
    margin-bottom: 52px;
  }

  .questionCard h1,
  .resultCard h1 {
    font-size: 34px;
  }

  .optionButton {
    grid-template-columns: 40px 1fr auto;
    min-height: 68px;
    padding-right: 12px;
  }

  .optionButton > span {
    width: 40px;
    height: 40px;
  }

  .resultActions {
    display: grid;
  }

  .blogRow {
    grid-template-columns: 34px 1fr;
    gap: 12px;
  }

  .blogRow h2 {
    font-size: 34px;
  }

  .blogMeta {
    flex-wrap: wrap;
  }

  .articleBody {
    font-size: 17px;
  }

  .articleBody blockquote {
    margin: 55px 0;
    padding-left: 22px;
    font-size: 30px;
  }

  .contactGrid {
    padding: 70px 0 100px;
  }

  .successCard {
    min-height: 420px;
    padding: 30px;
  }

  .adminLogin form {
    padding: 28px 20px;
  }

  .adminDashboard header {
    align-items: start;
    flex-direction: column;
  }
}

/* Dashboard direction */
.accountPage,
.adminDashboard {
  width: min(1480px, calc(100vw - 48px));
  margin: 24px auto 80px;
  padding: 32px;
  border: 1px solid rgba(23, 51, 45, 0.09);
  border-radius: 28px;
  background: #edf1ee;
}

.accountHeader,
.adminDashboard > header {
  padding: 30px;
  border: 0;
  border-radius: 22px;
  background: var(--teal-deep);
  color: var(--paper);
}

.accountHeader h1,
.adminDashboard > header h1 {
  font-family: 'Manrope', sans-serif;
  font-size: clamp(34px, 4vw, 58px);
  font-weight: 600;
  letter-spacing: -0.045em;
}

.accountHeader > div > p:last-child,
.adminDashboard > header p {
  color: rgba(255,255,255,.64);
}

.accountStats {
  gap: 14px;
  margin: 18px 0 48px;
  border: 0;
  background: transparent;
}

.accountStats article,
.adminEditorForm,
.accessForm,
.adminContentList,
.userDirectory {
  border: 0;
  border-radius: 20px;
  box-shadow: 0 12px 36px rgba(9,43,38,.06);
}

.accountStats article { min-height: 170px; }

.adminTabs {
  margin: 18px 0;
  padding: 8px;
  border-radius: 16px;
  background: var(--paper);
}

.adminTabs button {
  flex: 1;
  justify-content: center;
  border: 0;
  border-radius: 12px;
}

.adminWorkspace,
.accessWorkspace { gap: 18px; }

.optionEditor {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: 24px 1fr 1fr;
  gap: 12px;
  align-items: center;
}

.optionEditor input[type='radio'] { width: 18px; min-height: 18px; }

/* Admin content console */
.adminHint {
  display: flex;
  min-height: 74px;
  padding: 14px 16px;
  border: 1px dashed rgba(18, 60, 52, .28);
  background: rgba(18, 60, 52, .035);
  flex-direction: column;
  justify-content: center;
  gap: 5px;
}

.adminHint strong {
  color: var(--teal);
  font-size: 11px;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.adminHint span,
.adminListHeading span,
.adminEditBanner span {
  color: var(--ink-soft);
  font-size: 11px;
  line-height: 1.5;
}

.adminSectionLead {
  max-width: 720px;
  margin: -18px 0 34px;
  color: var(--ink-soft);
  font-size: 14px;
  line-height: 1.75;
}

.topicMediaGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.topicMediaGrid article {
  min-width: 0;
  padding: 12px;
  border: 1px solid var(--line);
  background: rgba(255, 255, 255, .22);
}

.topicMediaPreview {
  position: relative;
  display: grid;
  aspect-ratio: 1.15;
  overflow: hidden;
  background: rgba(18, 60, 52, .08);
  color: rgba(18, 60, 52, .35);
  place-items: center;
}

.topicMediaPreview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.topicMediaPreview > svg {
  width: 42px;
  height: 42px;
  stroke-width: 1.2;
}

.topicMediaPreview > span {
  position: absolute;
  top: 10px;
  left: 10px;
  display: grid;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(250, 246, 237, .9);
  color: var(--teal);
  font-size: 10px;
  place-items: center;
}

.topicMediaInfo {
  display: grid;
  padding: 18px 4px 16px;
  gap: 6px;
}

.topicMediaInfo strong {
  font-family: var(--display);
  font-size: 23px;
  font-weight: 400;
}

.topicMediaInfo span {
  overflow: hidden;
  color: var(--ink-soft);
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.topicMediaActions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.topicMediaActions label {
  cursor: pointer;
}

.topicMediaActions label[aria-disabled='true'] {
  cursor: wait;
  opacity: .55;
}

.topicMediaActions input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

.topicMediaActions .adminDangerButton {
  display: inline-flex;
  min-height: 42px;
  padding: 0 14px;
  border: 1px solid rgba(153, 56, 45, .3);
  background: transparent;
  color: #99382d;
  align-items: center;
  gap: 7px;
  cursor: pointer;
}

.topicMediaActions .adminDangerButton svg {
  width: 16px;
}

.topicMediaActions .adminDangerButton:hover {
  background: #99382d;
  color: var(--paper);
}

@media (max-width: 1023px) {
  .topicMediaGrid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

.adminEditBanner {
  display: flex;
  margin: -18px 0 30px;
  padding: 16px 18px;
  border-left: 3px solid var(--gold);
  background: rgba(182, 152, 98, .09);
  justify-content: space-between;
  align-items: center;
  gap: 18px;
}

.adminEditBanner > div {
  display: grid;
  gap: 3px;
}

.adminEditBanner button,
.questionBuilderHeading button,
.secondaryAdminButton {
  display: inline-flex;
  min-height: 42px;
  padding: 0 14px;
  border: 1px solid var(--line);
  background: transparent;
  color: var(--teal);
  align-items: center;
  justify-content: center;
  gap: 7px;
  cursor: pointer;
}

.adminEditBanner svg,
.questionBuilderHeading svg,
.secondaryAdminButton svg {
  width: 16px;
}

.adminListState {
  padding: 28px 0;
  border-top: 1px solid var(--line);
  color: var(--ink-soft);
  font-size: 13px !important;
  line-height: 1.6;
}

.adminContentList article.adminRowActive {
  margin: 0 -14px;
  padding-right: 14px;
  padding-left: 14px;
  background: rgba(182, 152, 98, .09);
}

.adminRowActions .adminDangerButton {
  border-color: rgba(153, 56, 45, .3);
  color: #99382d;
}

.adminRowActions button:hover,
.adminEditBanner button:hover,
.questionBuilderHeading button:hover,
.secondaryAdminButton:hover {
  border-color: var(--teal);
  background: var(--teal);
  color: var(--paper);
}

.adminRowActions .adminDangerButton:hover {
  border-color: #99382d;
  background: #99382d;
  color: var(--paper);
}

.adminRowActions button:focus-visible,
.adminEditBanner button:focus-visible,
.questionBuilderHeading button:focus-visible,
.secondaryAdminButton:focus-visible {
  outline: 3px solid rgba(182, 152, 98, .45);
  outline-offset: 2px;
}

.questionBuilder {
  display: grid;
  margin-top: 48px;
  gap: 20px;
}

.questionBuilderHeading {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 20px;
}

.questionBuilderHeading > div {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.questionBuilderHeading p { margin: 0; }

.questionBuilderHeading strong {
  font-family: var(--display);
  font-size: 34px;
  font-weight: 400;
}

.questionEditor {
  padding: clamp(20px, 3vw, 30px);
  border: 1px solid var(--line);
  background: rgba(255, 255, 255, .2);
}

.questionEditor > header {
  display: flex;
  margin-bottom: 26px;
  justify-content: space-between;
  align-items: start;
  gap: 16px;
}

.questionEditor > header > div {
  display: grid;
  gap: 4px;
}

.questionEditor > header span {
  color: var(--teal);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .1em;
  text-transform: uppercase;
}

.questionEditor > header strong {
  color: var(--ink-soft);
  font-size: 11px;
  font-weight: 500;
}

.questionEditor > header button,
.optionEditor > button {
  display: grid;
  width: 38px;
  height: 38px;
  border: 1px solid rgba(153, 56, 45, .24);
  background: transparent;
  color: #99382d;
  place-items: center;
  cursor: pointer;
}

.questionEditor > header button svg,
.optionEditor > button svg { width: 16px; }

.optionList {
  display: grid;
  margin-top: 26px;
  gap: 12px;
}

.optionEditor {
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr) minmax(0, 1fr) 38px;
  grid-column: 1 / -1;
  gap: 10px;
  align-items: center;
}

.optionEditor > label {
  display: grid;
  height: 48px;
  border: 1px solid var(--line);
  grid-template-columns: auto 1fr;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}

.optionEditor > label input {
  width: 16px;
  min-height: 16px;
  margin: 0;
  accent-color: var(--teal);
}

.optionEditor > label span {
  color: var(--ink-soft);
  font-size: 11px;
}

.optionEditor > input {
  width: 100%;
  min-height: 48px;
  padding: 0 12px;
  border: 1px solid var(--line);
  background: transparent;
  font: inherit;
}

.secondaryAdminButton { justify-self: start; }

.lessonMaterials {
  display: grid;
  grid-template-columns: minmax(240px, .58fr) minmax(0, 1.42fr);
  gap: 64px;
  margin: 84px 0;
  padding: 58px;
  border: 1px solid rgba(182, 152, 98, .42);
  border-radius: 28px;
  background:
    linear-gradient(135deg, rgba(182, 152, 98, .12), transparent 42%),
    var(--paper);
}

.lessonMaterials h2 {
  margin: 18px 0 0;
  font-family: var(--display);
  font-size: clamp(36px, 4vw, 58px);
  font-weight: 400;
  line-height: 1.05;
}

.lessonMaterials > div:first-child > p:last-child {
  max-width: 430px;
  margin: 24px 0 0;
  color: var(--ink-soft);
  font-size: 14px;
  line-height: 1.75;
}

.lessonMaterialList {
  display: grid;
  align-content: start;
}

.lessonMaterialList > button {
  display: grid;
  min-height: 104px;
  padding: 18px 0;
  border: 0;
  border-top: 1px solid var(--line);
  background: transparent;
  color: var(--ink);
  text-align: left;
  cursor: pointer;
  grid-template-columns: 52px minmax(0, 1fr) auto;
  align-items: center;
  gap: 18px;
}

.lessonMaterialList > button:last-of-type { border-bottom: 1px solid var(--line); }
.lessonMaterialList > button:disabled { cursor: wait; }

.lessonMaterialIcon {
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  border: 1px solid rgba(182, 152, 98, .55);
  border-radius: 50%;
  color: var(--gold);
  transition: color 220ms ease, background 220ms ease, transform 220ms var(--ease);
}

.lessonMaterialIcon svg { width: 20px; }

.lessonMaterialList > button:hover .lessonMaterialIcon,
.lessonMaterialList > button:focus-visible .lessonMaterialIcon {
  background: var(--gold);
  color: var(--teal-deep);
  transform: rotate(-4deg) scale(1.04);
}

.lessonMaterialList > button > span:nth-child(2) {
  display: grid;
  gap: 7px;
}

.lessonMaterialList strong {
  font-family: var(--display);
  font-size: 21px;
  font-weight: 400;
  line-height: 1.25;
}

.lessonMaterialList small {
  color: var(--ink-soft);
  font-size: 10px;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.lessonMaterialAction {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: var(--teal);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
}

.lessonMaterialAction svg {
  width: 17px;
  transition: transform 220ms var(--ease);
}

.lessonMaterialList > button:hover .lessonMaterialAction svg,
.lessonMaterialList > button:focus-visible .lessonMaterialAction svg { transform: translateY(3px); }

.lessonMaterialState {
  min-height: 104px;
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: linear-gradient(90deg, transparent, rgba(217, 198, 164, .35), transparent);
  background-size: 220% 100%;
  animation: portalPulse 1.6s ease infinite;
}

.lessonMaterialError {
  display: flex;
  min-height: 104px;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  color: var(--error);
}

.lessonMaterialError button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 44px;
  padding: 0 14px;
  border: 1px solid currentColor;
  border-radius: 100px;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.lessonMaterialError svg { width: 16px; }

.lessonAssessments {
  display: grid;
  grid-template-columns: minmax(220px, .55fr) minmax(0, 1.45fr);
  gap: 64px;
  margin: 84px 0;
  padding: 54px 0;
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.lessonAssessments h2 {
  margin: 18px 0 0;
  font-family: var(--display);
  font-size: clamp(36px, 4vw, 58px);
  font-weight: 400;
  line-height: 1.05;
}

.lessonAssessments > div:last-child {
  display: grid;
}

.lessonAssessments a {
  display: grid;
  min-height: 92px;
  padding: 18px 0;
  border-top: 1px solid var(--line);
  color: var(--ink);
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 18px;
}

.lessonAssessments a:last-child { border-bottom: 1px solid var(--line); }
.lessonAssessments a > svg:first-child { color: var(--gold); }
.lessonAssessments a > svg:last-child { transition: transform .2s ease; }
.lessonAssessments a:hover > svg:last-child { transform: translateX(5px); }

.lessonAssessments a span {
  display: grid;
  gap: 5px;
}

.lessonAssessments a strong {
  font-family: var(--display);
  font-size: 22px;
  font-weight: 400;
}

.lessonAssessments a small {
  color: var(--ink-soft);
  font-size: 11px;
  text-transform: uppercase;
}

@media (max-width: 767px) {
  .accountPage,
  .adminDashboard {
    width: calc(100vw - 16px);
    margin-top: 8px;
    padding: 12px;
    border-radius: 20px;
  }
  .accountHeader,
  .adminDashboard > header { padding: 22px; }
  .adminTabs button { flex: 0 0 auto; }
  .optionEditor { grid-template-columns: 24px 1fr; }
  .optionEditor input:last-child { grid-column: 2; }
  .adminEditBanner { align-items: stretch; flex-direction: column; }
  .adminEditBanner button { align-self: start; }
  .questionBuilderHeading { align-items: stretch; flex-direction: column; }
  .questionBuilderHeading button { align-self: start; }
  .optionEditor { grid-template-columns: 48px minmax(0, 1fr) 38px; }
  .optionEditor > label { grid-column: 1; grid-row: 1; }
  .optionEditor > input:nth-of-type(1) { grid-column: 2 / 4; grid-row: 1; }
  .optionEditor > button { grid-column: 1; grid-row: 2; }
  .optionEditor > input:nth-of-type(2) { grid-column: 2 / 4; grid-row: 2; }
  .lessonMaterials {
    grid-template-columns: 1fr;
    gap: 34px;
    margin: 64px 0;
    padding: 36px 22px;
    border-radius: 22px;
  }
  .lessonMaterialList > button {
    grid-template-columns: 48px minmax(0, 1fr);
    gap: 14px;
  }
  .lessonMaterialAction {
    grid-column: 2;
    justify-self: start;
  }
  .lessonMaterialError { align-items: flex-start; flex-direction: column; padding: 20px 0; }
  .lessonAssessments { grid-template-columns: 1fr; gap: 32px; margin: 64px 0; padding: 42px 0; }
  .topicMediaGrid { grid-template-columns: 1fr; }
}

.accountHeaderActions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

.accountHeaderActions > button,
.dashboardButton {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 46px;
  padding: 0 16px;
  border: 1px solid rgba(255,255,255,.24);
  border-radius: 12px;
  background: transparent;
  color: var(--paper);
  cursor: pointer;
}

.dashboardButton {
  border-color: var(--gold);
  background: var(--gold);
  color: var(--teal-deep);
  font-weight: 700;
}

.accountHeaderActions svg { width: 18px; }

@media (max-width: 767px) {
  .accountHeaderActions { justify-content: flex-start; }
}

/* Series, learning analytics and protected embeds */
.lessonHeader {
  grid-template-columns: 1fr;
}

.youtubeEmbedGuard {
  position: absolute;
  inset: 0;
}

.youtubeEmbedGuard iframe {
  width: 100%;
  height: 100%;
}

.youtubeEmbedGuard::before,
.youtubeEmbedGuard::after {
  position: absolute;
  z-index: 3;
  right: 0;
  left: 0;
  height: 18%;
  content: '';
}

.youtubeEmbedGuard::before { top: 0; }
.youtubeEmbedGuard::after { bottom: 0; height: 15%; }

.seriesCard .lessonBody {
  min-height: 205px;
}

.seriesExcerpt {
  display: -webkit-box;
  margin: 12px 0 0;
  overflow: hidden;
  color: var(--ink-soft);
  font-size: 13px;
  line-height: 1.6;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.seriesPage {
  width: var(--container);
  margin: 0 auto;
  padding: 56px 0 130px;
}

.seriesPage > .backLink {
  margin-bottom: 28px;
}

.seriesHero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 220px;
  gap: 60px;
  align-items: end;
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid var(--line);
}

.seriesHero h1 {
  max-width: 1000px;
  margin: 12px 0 0;
  font-size: clamp(30px, 3.6vw, 52px);
  line-height: 1.12;
  overflow-wrap: anywhere;
}

.seriesDescription {
  max-width: 720px;
  margin: 16px 0 0;
  color: var(--ink-soft);
  font-size: 17px;
  line-height: 1.75;
}

.seriesTrailer {
  width: min(100%, 448px);
  aspect-ratio: 16 / 9;
  margin-bottom: 32px;
}

.seriesTrailer > video {
  pointer-events: none;
}

.seriesTrailer:is(:hover, :focus-visible) .playDisc {
  transform: scale(1.08);
}

.seriesCounter {
  display: grid;
  padding: 28px;
  border: 1px solid var(--line);
}

.seriesCounter strong {
  font-family: var(--display);
  font-size: 72px;
  font-weight: 400;
  line-height: 1;
}

.seriesCounter span,
.seriesCounter small {
  margin-top: 10px;
  color: var(--ink-soft);
  font-size: 11px;
  text-transform: uppercase;
}

.seriesCounter small { color: var(--gold); }

.adminRowActions {
  display: flex;
  gap: 8px;
}

.adminRowActions button {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border: 1px solid var(--line);
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
}

.progressWorkspace {
  padding: 30px;
  border-radius: 20px;
  background: var(--paper);
  box-shadow: 0 12px 36px rgba(9,43,38,.06);
}

.progressHeading {
  display: flex;
  justify-content: space-between;
  align-items: end;
  margin-bottom: 28px;
}

.progressHeading h2 { font-size: clamp(32px, 4vw, 54px); }
.progressHeading strong { font-family: var(--display); font-size: 58px; font-weight: 400; }

.studentProgressGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.studentProgressCard {
  padding: 24px;
  border: 1px solid var(--line);
  border-radius: 18px;
}

.studentProgressIdentity {
  display: flex;
  align-items: center;
  gap: 14px;
}

.studentProgressIdentity > span {
  display: grid;
  place-items: center;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: var(--teal);
  color: var(--paper);
}

.studentProgressIdentity h3 { margin: 0; font-size: 18px; }
.studentProgressIdentity p { margin: 4px 0 0; color: var(--ink-soft); font-size: 12px; }

/* Dedicated admin application shell */
.adminShell {
  display: grid;
  min-height: 100vh;
  background: #f4f3ee;
  color: var(--ink);
  grid-template-columns: 272px minmax(0, 1fr);
}

.adminSidebar {
  position: sticky;
  z-index: 30;
  top: 0;
  display: flex;
  height: 100vh;
  min-height: 640px;
  padding: 22px 16px;
  overflow-y: auto;
  background: #0d2924;
  color: var(--paper);
  flex-direction: column;
}

.adminBrand {
  display: grid;
  min-height: 68px;
  padding: 0 8px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, .1);
  grid-template-columns: 44px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
}

.adminBrand > span {
  display: grid;
  width: 44px;
  height: 44px;
  border: 1px solid rgba(255, 255, 255, .26);
  border-radius: 13px;
  color: var(--cream);
  font-family: var(--display);
  font-size: 15px;
  place-items: center;
}

.adminBrand > div,
.adminSidebarFooter p {
  display: grid;
  min-width: 0;
  margin: 0;
  gap: 3px;
}

.adminBrand strong,
.adminSidebarFooter strong {
  overflow: hidden;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.adminBrand small,
.adminSidebarFooter small {
  color: rgba(255, 255, 255, .48);
  font-size: 10px;
  letter-spacing: .06em;
  text-transform: uppercase;
}

.adminBrand > button {
  display: none;
  width: 40px;
  height: 40px;
  border: 0;
  background: transparent;
  color: inherit;
  place-items: center;
}

.adminSidebar nav {
  display: grid;
  padding: 22px 0;
  gap: 5px;
}

.adminSidebar nav a {
  display: grid;
  min-height: 58px;
  padding: 9px 12px;
  border: 1px solid transparent;
  border-radius: 12px;
  color: rgba(255, 255, 255, .66);
  grid-template-columns: 22px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  transition: color .2s ease, background .2s ease, transform .2s ease;
}

.adminSidebar nav a:hover {
  background: rgba(255, 255, 255, .06);
  color: var(--paper);
  transform: translateX(2px);
}

.adminSidebar nav a.adminSidebarLinkActive {
  border-color: rgba(217, 198, 164, .22);
  background: #f0e6d3;
  color: var(--teal-deep);
}

.adminSidebar nav svg {
  width: 19px;
  height: 19px;
  stroke-width: 1.8;
}

.adminSidebar nav a > span {
  display: grid;
  gap: 2px;
}

.adminSidebar nav strong {
  font-size: 13px;
  font-weight: 650;
}

.adminSidebar nav small {
  color: inherit;
  font-size: 9px;
  opacity: .58;
}

.adminSidebarFooter {
  display: grid;
  margin-top: auto;
  padding: 18px 8px 0;
  border-top: 1px solid rgba(255, 255, 255, .1);
  gap: 14px;
}

.adminSidebarFooter > div {
  display: grid;
  min-width: 0;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
}

.adminSidebarFooter > div > span {
  display: grid;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: rgba(255, 255, 255, .1);
  color: var(--sand);
  font-size: 13px;
  font-weight: 700;
  place-items: center;
}

.adminSidebarFooter > button {
  display: inline-flex;
  min-height: 42px;
  padding: 0 12px;
  border: 1px solid rgba(255, 255, 255, .12);
  border-radius: 10px;
  background: transparent;
  color: rgba(255, 255, 255, .72);
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}

.adminSidebarFooter > button:hover {
  border-color: rgba(255, 255, 255, .3);
  color: var(--paper);
}

.adminSidebarFooter svg { width: 16px; }

.adminPanel { min-width: 0; }

.adminTopbar {
  position: sticky;
  z-index: 20;
  top: 0;
  display: grid;
  height: 76px;
  padding: 0 clamp(24px, 4vw, 56px);
  border-bottom: 1px solid rgba(23, 51, 45, .09);
  background: rgba(244, 243, 238, .94);
  backdrop-filter: blur(14px);
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
}

.adminTopbarTitle {
  display: grid;
  gap: 2px;
}

.adminTopbarTitle span {
  color: var(--ink-soft);
  font-size: 9px;
  letter-spacing: .09em;
  text-transform: uppercase;
}

.adminTopbarTitle strong { font-size: 13px; }

.adminTopbarActions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.adminTopbarActions a,
.adminMenuButton {
  display: inline-flex;
  min-height: 42px;
  padding: 0 14px;
  border: 1px solid var(--line);
  border-radius: 11px;
  background: rgba(255, 255, 255, .6);
  color: var(--teal);
  align-items: center;
  gap: 8px;
  transition: background .2s ease, border-color .2s ease;
}

.adminTopbarActions a:hover { border-color: rgba(18, 60, 52, .35); background: var(--paper); }
.adminTopbar svg { width: 17px; }
.adminMenuButton { display: none; width: 42px; padding: 0; justify-content: center; cursor: pointer; }

.adminMain {
  width: 100%;
  max-width: 1540px;
  margin: 0 auto;
  padding: clamp(32px, 4.5vw, 68px) clamp(24px, 4vw, 56px) 80px;
}

.adminPageHeading {
  display: flex;
  min-height: 140px;
  margin-bottom: 34px;
  justify-content: space-between;
  align-items: flex-end;
  gap: 32px;
}

.adminPageHeading h1 {
  margin: 10px 0 12px;
  font-family: 'Manrope', sans-serif;
  font-size: clamp(36px, 4vw, 58px);
  font-weight: 600;
  letter-spacing: -.045em;
  line-height: 1;
}

.adminPageHeading > div > p:last-child {
  max-width: 680px;
  margin: 0;
  color: var(--ink-soft);
  font-size: 14px;
  line-height: 1.65;
}

.adminPrimaryAction,
.adminSecondaryAction,
.adminCancelButton {
  display: inline-flex;
  min-height: 48px;
  padding: 0 18px;
  border: 1px solid var(--teal);
  border-radius: 12px;
  background: var(--teal);
  color: var(--paper);
  font-size: 13px;
  font-weight: 650;
  align-items: center;
  justify-content: center;
  gap: 9px;
  white-space: nowrap;
  cursor: pointer;
  transition: transform .2s ease, background .2s ease;
}

.adminPrimaryAction:hover { background: var(--teal-deep); transform: translateY(-1px); }
.adminPrimaryAction svg,
.adminSecondaryAction svg,
.adminCancelButton svg { width: 17px; }

.adminSecondaryAction,
.adminCancelButton {
  border-color: var(--line);
  background: rgba(255, 255, 255, .5);
  color: var(--teal);
}

.adminSecondaryAction:hover,
.adminCancelButton:hover { border-color: var(--teal); background: var(--paper); }

.adminShell .adminEditorForm,
.adminShell .adminContentList,
.adminShell .accessForm,
.adminShell .userDirectory,
.adminShell .progressWorkspace {
  border: 1px solid rgba(23, 51, 45, .1);
  border-radius: 18px;
  background: #fcfaf5;
  box-shadow: 0 16px 40px rgba(9, 43, 38, .045);
}

.adminShell .adminEditorForm,
.adminShell .adminContentList { padding: clamp(22px, 3vw, 34px); }
.adminShell .adminWorkspace,
.adminShell .accessWorkspace { gap: 20px; }

.adminShell .adminFormHeading { margin-bottom: 30px; }
.adminShell .adminFormHeading h2 { font-family: 'Manrope', sans-serif; font-size: clamp(25px, 2.5vw, 34px); font-weight: 600; letter-spacing: -.035em; }
.adminShell .adminFormHeading > span { width: 46px; height: 46px; border-radius: 13px; background: rgba(18, 60, 52, .06); }

.adminShell .adminEditorForm label { gap: 9px; }
.adminShell .adminEditorForm label > span { color: var(--ink-soft); font-size: 10px; letter-spacing: .08em; }
.adminShell .adminEditorForm input,
.adminShell .adminEditorForm select,
.adminShell .adminEditorForm textarea {
  width: 100%;
  min-height: 50px;
  padding: 12px 14px;
  border: 1px solid rgba(23, 51, 45, .16);
  border-radius: 10px;
  background: rgba(255, 255, 255, .72);
  transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
}

.adminShell .adminEditorForm textarea { min-height: 120px; resize: vertical; }
.adminShell .adminEditorForm .adminCheckbox input { width: 18px; min-height: 18px; padding: 0; }
.adminShell .adminEditorForm input:focus,
.adminShell .adminEditorForm select:focus,
.adminShell .adminEditorForm textarea:focus {
  outline: 0;
  border-color: rgba(18, 60, 52, .58);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(18, 60, 52, .08);
}

.adminVideoForm { max-width: 1020px; }
.adminFormActions { display: flex; margin-top: 28px; align-items: center; gap: 12px; }
.adminShell .adminEditorForm > .primaryButton { margin-top: 0; border-radius: 12px; }
.adminFileField { padding: 18px; border: 1px dashed rgba(18, 60, 52, .25); border-radius: 12px; background: rgba(18, 60, 52, .025); }

.adminVideoList { width: 100%; max-height: none; overflow: visible; }
.adminShell .adminListHeading { padding-bottom: 22px; }
.adminShell .adminListHeading strong { display: grid; width: 52px; height: 52px; border-radius: 14px; background: rgba(18, 60, 52, .06); font-family: 'Manrope', sans-serif; font-size: 19px; font-weight: 650; place-items: center; }
.adminShell .adminContentList article {
  min-height: 96px;
  padding: 20px 0;
  border-top: 1px solid rgba(23, 51, 45, .1);
  align-items: center;
  gap: 24px;
}
.adminShell .adminContentList article > div:first-child { min-width: 0; }
.adminShell .adminContentList h3 { margin: 7px 0 5px; font-family: 'Manrope', sans-serif; font-size: 17px; font-weight: 650; }
.adminShell .adminContentList p { margin: 0; }
.adminShell .adminContentList article > div:first-child > span { color: #62766f; font-size: 9px; letter-spacing: .07em; text-transform: uppercase; }

.adminEmptyState {
  display: grid;
  min-height: 300px;
  padding: 36px;
  border-top: 1px solid var(--line);
  text-align: center;
  align-content: center;
  justify-items: center;
  gap: 10px;
}
.adminEmptyState > svg { width: 44px; height: 44px; margin-bottom: 8px; padding: 11px; border-radius: 13px; background: rgba(18, 60, 52, .06); }
.adminEmptyState strong { font-size: 16px; }
.adminEmptyState span { max-width: 360px; color: var(--ink-soft); font-size: 13px; line-height: 1.6; }

.adminShell .adminRowActions { flex-shrink: 0; }
.adminShell .adminRowActions button { border-radius: 11px; background: rgba(255, 255, 255, .65); }

.seriesAccessControl {
  display: grid;
  max-width: 320px;
  margin-top: 14px;
  gap: 6px;
}
.seriesAccessControl > span {
  font-size: 9px !important;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
}
.seriesAccessControl select {
  min-height: 42px;
  padding: 8px 34px 8px 12px;
  border: 1px solid rgba(18, 60, 52, .2);
  border-radius: 10px;
  background: rgba(255, 255, 255, .7);
  color: var(--ink);
}
.seriesAccessControl select:focus-visible {
  outline: 3px solid rgba(182, 152, 98, .35);
  outline-offset: 2px;
}

.adminListBack {
  display: inline-flex;
  min-height: 38px;
  margin: 0 0 14px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--teal);
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.adminListBack svg { width: 16px; }
.adminListBack:hover { color: var(--gold); }
.adminListBack:focus-visible {
  outline: 3px solid rgba(182, 152, 98, .35);
  outline-offset: 4px;
}

.topicMediaSection { display: grid; gap: 24px; }
.topicMediaGuide {
  display: grid;
  max-width: 880px;
  padding: 18px 20px;
  border: 1px solid rgba(182, 152, 98, .25);
  border-radius: 14px;
  background: #eee6d8;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: center;
  gap: 14px;
}
.topicMediaGuide > span { display: grid; width: 42px; height: 42px; border-radius: 12px; background: rgba(255, 255, 255, .5); color: var(--teal); place-items: center; }
.topicMediaGuide svg { width: 19px; }
.topicMediaGuide strong { font-size: 13px; }
.topicMediaGuide p { margin: 4px 0 0; color: var(--ink-soft); font-size: 12px; line-height: 1.55; }

.adminShell .topicMediaGrid { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 18px; }
.adminShell .topicMediaGrid article {
  min-width: 0;
  padding: 0;
  overflow: hidden;
  border: 1px solid rgba(23, 51, 45, .12);
  border-radius: 17px;
  background: #fcfaf5;
  box-shadow: 0 12px 30px rgba(9, 43, 38, .035);
}
.adminShell .topicMediaPreview { aspect-ratio: 16 / 10; background: #e7e8e1; }
.adminShell .topicMediaPreview::after { position: absolute; inset: 0; border: 1px solid rgba(255, 255, 255, .25); content: ''; pointer-events: none; }
.adminShell .topicMediaPreview img { transition: transform .45s ease; }
.adminShell .topicMediaGrid article:hover .topicMediaPreview img { transform: scale(1.025); }
.adminShell .topicMediaPreview > div { display: grid; color: rgba(18, 60, 52, .38); justify-items: center; gap: 10px; }
.adminShell .topicMediaPreview > div svg { width: 30px; height: 30px; stroke-width: 1.4; }
.adminShell .topicMediaPreview > div span { font-size: 11px; }
.topicMediaBody { padding: 18px; }
.adminShell .topicMediaInfo { display: grid; padding: 0 0 16px; grid-template-columns: 34px minmax(0, 1fr); align-items: center; gap: 11px; }
.adminShell .topicMediaInfo > span { display: grid; width: 34px; height: 34px; border-radius: 10px; background: rgba(18, 60, 52, .06); color: var(--teal); font-size: 10px; place-items: center; }
.adminShell .topicMediaInfo > div { display: grid; gap: 3px; }
.adminShell .topicMediaInfo strong { overflow: hidden; font-family: 'Manrope', sans-serif; font-size: 15px; font-weight: 650; text-overflow: ellipsis; white-space: nowrap; }
.adminShell .topicMediaInfo small { overflow: hidden; color: var(--ink-soft); font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }
.adminShell .topicMediaActions { padding-top: 14px; border-top: 1px solid rgba(23, 51, 45, .1); align-items: center; }
.adminShell .topicMediaActions .secondaryAdminButton { flex: 1; min-height: 44px; border-radius: 10px; }
.adminShell .topicMediaActions .adminDangerButton { width: 44px; height: 44px; min-height: 44px; padding: 0; border-radius: 10px; justify-content: center; }

.adminSidebarBackdrop { display: none; }

@media (max-width: 1180px) {
  .adminShell .topicMediaGrid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 1023px) {
  .adminShell { grid-template-columns: 1fr; }
  .adminSidebar { position: fixed; left: 0; width: min(292px, calc(100vw - 44px)); transform: translateX(-105%); transition: transform .25s ease; }
  .adminSidebarOpen { transform: translateX(0); }
  .adminBrand > button { display: grid; cursor: pointer; }
  .adminSidebarBackdrop { position: fixed; z-index: 25; inset: 0; display: block; border: 0; background: rgba(4, 20, 17, .45); opacity: 0; pointer-events: none; transition: opacity .25s ease; }
  .adminSidebarBackdropVisible { opacity: 1; pointer-events: auto; }
  .adminMenuButton { display: inline-flex; }
  .adminShell .adminWorkspace,
  .adminShell .accessWorkspace { grid-template-columns: 1fr; }
}

@media (max-width: 767px) {
  .adminTopbar { height: 68px; padding: 0 14px; }
  .adminTopbarActions { gap: 6px; }
  .adminTopbarActions a { width: 42px; padding: 0; justify-content: center; }
  .adminTopbarActions a span { display: none; }
  .adminMain { padding: 28px 14px 60px; }
  .adminPageHeading { min-height: 0; margin-bottom: 26px; align-items: stretch; flex-direction: column; gap: 20px; }
  .adminPageHeading h1 { font-size: 36px; }
  .adminPrimaryAction,
  .adminSecondaryAction { align-self: stretch; }
  .adminShell .adminEditorForm,
  .adminShell .adminContentList { padding: 20px 16px; border-radius: 15px; }
  .adminShell .adminFieldGrid { grid-template-columns: 1fr; }
  .adminShell .adminFullField { grid-column: auto; }
  .adminFormActions { align-items: stretch; flex-direction: column; }
  .adminFormActions > * { width: 100%; }
  .adminShell .adminContentList article { display: flex; align-items: stretch; flex-direction: column; }
  .adminShell .adminRowActions { width: 100%; justify-content: flex-start; }
  .adminShell .topicMediaGrid { grid-template-columns: 1fr; }
  .topicMediaGuide { align-items: start; }
}

@media (prefers-reduced-motion: reduce) {
  .adminSidebar,
  .adminSidebar nav a,
  .adminPrimaryAction,
  .adminShell .topicMediaPreview img { transition: none; }
}

.studentProgressBar {
  height: 5px;
  margin: 22px 0;
  overflow: hidden;
  border-radius: 10px;
  background: rgba(18,60,52,.1);
}

.studentProgressBar span { display: block; height: 100%; background: var(--gold); }

.studentProgressStats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.studentProgressStats span {
  display: grid;
  gap: 5px;
  color: var(--ink-soft);
  font-size: 10px;
}

.studentProgressStats svg { width: 17px; }
.studentProgressStats strong { color: var(--ink); font-size: 18px; }

.studentProgressFoot {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 22px;
  padding-top: 16px;
  border-top: 1px solid var(--line);
  color: var(--ink-soft);
  font-size: 10px;
}

.progressEmpty { display: grid; place-items: center; min-height: 240px; color: var(--ink-soft); }

.accountStats { grid-template-columns: repeat(4, minmax(0, 1fr)); }

.accountProgressSection { margin-top: 80px; }

.accountProgressList {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.accountProgressList > a {
  display: grid;
  grid-template-columns: 44px 1fr auto;
  gap: 14px;
  align-items: center;
  min-height: 82px;
  padding: 16px;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: var(--paper);
}

.accountProgressList > a > span {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(18,60,52,.08);
}

.accountProgressList .progressDone { background: var(--teal); color: var(--paper); }
.accountProgressList strong { display: block; }
.accountProgressList small { display: block; margin-top: 4px; color: var(--ink-soft); }
.accountProgressList em { color: var(--ink-soft); font-size: 11px; font-style: normal; }

.quizAttemptList {
  display: grid;
  gap: 10px;
}

.quizAttemptList article {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 72px;
  padding: 16px 20px;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: var(--paper);
}

.quizAttemptList article span { display: block; margin-top: 5px; color: var(--ink-soft); font-size: 11px; }
.quizAttemptList article b { font-family: var(--display); font-size: 28px; font-weight: 400; }

@media (max-width: 1023px) {
  .accountStats { grid-template-columns: repeat(2, 1fr); }
  .studentProgressGrid { grid-template-columns: 1fr; }
}

@media (max-width: 767px) {
  .seriesPage { width: calc(100vw - 32px); padding: 32px 0 90px; }
  .seriesHero { grid-template-columns: 1fr; gap: 30px; }
  .seriesHero h1 { font-size: clamp(26px, 7vw, 34px); }
  .seriesCounter { width: 100%; }
  .progressWorkspace { padding: 18px; }
  .studentProgressStats { grid-template-columns: 1fr 1fr 1fr; }
  .studentProgressFoot { flex-direction: column; }
  .accountStats { grid-template-columns: 1fr; }
  .accountProgressList { grid-template-columns: 1fr; }
  .accountProgressList > a { grid-template-columns: 44px 1fr; }
  .accountProgressList em { grid-column: 2; }
}
